module.exports = __webpack_public_path__ + "static/media/Precios Español.91676fde.png";